import { Controller } from "@hotwired/stimulus"

// Locks the embed in expanded state when clicking anywhere in the iframe
export default class extends Controller {
    connect() {
        this.locked = false
        this.boundClickHandler = this.handleClick.bind(this)
        this.element.addEventListener('click', this.boundClickHandler)
    }

    disconnect() {
        this.element.removeEventListener('click', this.boundClickHandler)
    }

    handleClick() {
        if (this.locked) return

        this.locked = true

        // Notify parent window to lock the embed
        if (window.self !== window.top) {
            window.parent.postMessage({ type: 'ai_mode_prompts_state', state: 'locked' }, '*')
        }
    }
}
